import { render, staticRenderFns } from "./EmployeeConcerns.vue?vue&type=template&id=642de8b8&scoped=true"
import script from "./EmployeeConcerns.vue?vue&type=script&lang=js"
export * from "./EmployeeConcerns.vue?vue&type=script&lang=js"
import style0 from "./EmployeeConcerns.vue?vue&type=style&index=0&id=642de8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642de8b8",
  null
  
)

export default component.exports